export default __webpack_public_path__ + "static/media/heikin-ashi.96a5569d.svg";